import css from './table-cell.module.css'

import type {
  TableCellAlignment,
  TableCellType,
  TableCellVariant,
} from './table-cell.types'

export const styles = {
  base: css.cell,
}

export const alignmentStyles: Record<TableCellAlignment, string> = {
  left: css.alignLeft,
  center: css.alignCenter,
  right: css.alignRight,
}

export const typeStyles: Record<TableCellType, string> = {
  text: css.typeText,
  icon: css.typeIcon,
  heading: css.typeHeading,
}

export const variantStyles: Record<TableCellVariant, string> = {
  page: css.variantPage,
  'light-1': css.variantLight1,
  'light-2': css.variantLight2,
  'dark-1': css.variantDark1,
  'dark-2': css.variantDark2,
}
